import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col
} from "reactstrap";

import { PanelHeader } from "components";

import { loghead as thead, logbody as tbody } from "variables/general";
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

import { DatePicker, Modal, TimePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Avatar, Card as LoadingCard, Skeleton, Switch } from 'antd';
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;
const dateFormat = "DD/MM/YYYY";
const weekFormat = "w: MMMM YYYY";
const customFormat = (value) => `Semana ${value.format(weekFormat)}`;

const showPassword = false;

class Log extends React.Component {
  render() {
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card className="lista-vpn">
                <CardHeader>
                  <CardTitle tag="h4">Log de conexiones</CardTitle>
                </CardHeader>
                <CardBody>
                  Filtrar por fechas{" "}
                  <RangePicker
                    onChange={value => {
                      // this.setState({ filterRange: value }, () =>
                      //   this.loadCheckins()
                      // );
                    }}
                    // status={this.state.filterRange ? null : "error"}
                    format={dateFormat}
                    // value={this.state.filterRange}
                    defaultOpenValue={dayjs()}
                    size="large"
                    // style={{ width: "100%" }}
                    // disabled={this.state.isLoadingCheckins}
                  />
                </CardBody>
                <CardBody className="table-full-width">
                  <Table responsive striped bordered hover>
                    <thead className="text-primary">
                      <tr>
                        {thead.map((prop, key) => {
                          if (key === thead.length - 1)
                            return (
                              <th key={key} className="text-left">
                                {prop}
                              </th>
                            );
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {tbody.map((prop, key) => {
                        return (
                          <tr key={key} className={prop.className}>
                            {prop.data.map((prop, key) => {
                              if (key === thead.length - 1)
                                return (
                                  <td key={key} className="text-left">
                                    {prop}
                                  </td>
                                );
                              return <td key={key}>{prop}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Log;



// WEBPACK FOOTER //
// ./src/views/Log/Log.jsx